import {ContextMessage as Message} from '@epic-core/localization';
import PropTypes from 'prop-types';
import React from 'react';

import StandingTeamStat from './StandingTeamStat';

export default class StandingItem extends React.PureComponent {
  static propTypes = {
    standing: PropTypes.object,
  };
  render() {
    const {link, teams, title, ctaText, subtitle} = this.props.standing;
    const teamsList = teams || [];
    const ranks = teamsList.map((teamList, index) => {
      const key = `rank-${index}`;
      return <StandingTeamStat key={key} team={teamList} />;
    });
    const colA = [];
    const colB = [];
    for (let x = 0; x < ranks.length; x++) {
      if (x <= 9) {
        colA.push(ranks[x]);
      } else {
        colB.push(ranks[x]);
      }
    }
    return (
      <div className="standing-item container-fluid text-center">
        {subtitle ? <h2>{subtitle}</h2> : null}
        <h1>{title}</h1>
        <div className="row">
          <div className="standings">
            <ul className="col-md-12 col-lg-6">
              <div className="row rowHeaders">
                <div className="col-lg-7">
                  <h5>
                    <Message code="epic.fortnite.skirmish.standing.name" />
                  </h5>
                </div>
                <div className="col-lg-2">
                  <h5>
                    <Message code="epic.fortnite.skirmish.standing.prize" />
                  </h5>
                </div>
                <div className="col-lg-1">
                  <h5>
                    <Message code="epic.fortnite.skirmish.standing.club" />
                  </h5>
                </div>
                <div className="col-lg-2">
                  <h5>
                    <Message code="epic.fortnite.skirmish.standing.points" />
                  </h5>
                </div>
              </div>
              <div className="row">{colA}</div>
            </ul>
            <ul className="col-md-12 col-lg-6">
              <div className="row rowHeaders">
                <div className="col-lg-7">
                  <h5>
                    <Message code="epic.fortnite.skirmish.standing.name" />
                  </h5>
                </div>
                <div className="col-lg-2">
                  <h5>
                    <Message code="epic.fortnite.skirmish.standing.prize" />
                  </h5>
                </div>
                <div className="col-lg-1">
                  <h5>
                    <Message code="epic.fortnite.skirmish.standing.club" />
                  </h5>
                </div>
                <div className="col-lg-2">
                  <h5>
                    <Message code="epic.fortnite.skirmish.standing.points" />
                  </h5>
                </div>
              </div>
              <div className="row">{colB}</div>
            </ul>
          </div>
        </div>
        {link ? (
          <div className="btnWrapper">
            <a href={link} rel="noopener noreferrer" target="_blank" className="skirmishBtn">
              <i className="icon-tv" />
              <span>{ctaText}</span>
            </a>
          </div>
        ) : null}
      </div>
    );
  }
}
